import { render, staticRenderFns } from "./VentMonitor.vue?vue&type=template&id=175f046e&scoped=true&"
import script from "./VentMonitor.vue?vue&type=script&lang=ts&"
export * from "./VentMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./VentMonitor.vue?vue&type=style&index=0&id=175f046e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f046e",
  null
  
)

export default component.exports